export default "__VITE_ASSET__BBHUUUnm__"